import { Component, AfterViewInit, ElementRef, ViewChild, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-secure-frame',
  template: `<iframe #containerEl sandbox="allow-same-origin allow-top-navigation allow-popups" [attr.data-automation-id]="'bc-secure-iframe'"></iframe>`
})
export class SecureFrameComponent implements AfterViewInit {
  @Input()
  content: string;

  @Input()
  emailId: string;

  @Output()
  onLoad: EventEmitter<void> = new EventEmitter();

  @ViewChild('containerEl', { static: true })
  iFrameRef: ElementRef;

  private _iFrameEl: HTMLIFrameElement;

  ngAfterViewInit() {
    this._iFrameEl = this.iFrameRef.nativeElement;
    this._iFrameEl.onload = this._onFrameLoaded.bind(this);

    this._setFrameProperties();

    this._writeContentIntoFrame();
  }

  private _setFrameProperties() {
    this._iFrameEl.name = `app-secure-frame_${this.emailId}`;
    this._iFrameEl.scrolling = 'no';
    this._iFrameEl.frameBorder = '0';
    this._iFrameEl.style.width = '100%';
    this._iFrameEl.style.border = '0';
    this._iFrameEl.style.overflowX = 'auto';
  }

  private _writeContentIntoFrame() {
    this._iFrameEl.contentWindow.document.open();
    this._iFrameEl.contentWindow.document.write(this._generateContent());
    this._iFrameEl.contentWindow.document.close();
  }

  private _generateContent() {
    return `<div class="email-message">${this.content}</div>`;
  }

  private _onFrameLoaded() {
    this._expandToContentHeight();

    this._changeAnchorTargetsToBlank();

    setTimeout(() => {
      this.onLoad.emit();
    }, 0);
  }

  private _expandToContentHeight() {
    const contentBody = this._iFrameEl.contentDocument.body;

    contentBody.style.margin = '0';

    const contentHeight = contentBody.scrollHeight || contentBody.offsetHeight;
    const contentWidth = contentBody.scrollWidth || contentBody.offsetWidth;

    this._iFrameEl.style.height = `${contentHeight}px`;
    this._iFrameEl.style.minWidth = `${contentWidth - 10}px`;
  }

  private _changeAnchorTargetsToBlank() {
    const anchors = this._iFrameEl.contentDocument.getElementsByTagName('a');

    for (let i = 0, len = anchors.length; i < len; i++) {
      anchors[i].target = '_blank';
    }
  }
}
